import React, { Component } from 'react'
import { connect } from 'react-redux'
import { addProduct } from '../actions'
import ProductFormInput from './ProductFormInput'
import Button from './Button'

class ProductForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      feedback: {
        message: '',
        type: ''
      },
      isSubmitting: false,
      newProduct: {
        id: '',
        name: '',
        quantity: 0,
        brand: '',
        bought: false
      }
    }
  }

  updateNewProductProperty = (property, value) => {
    this.setState(prevState => ({
      ...prevState,
      newProduct: {
        ...prevState.newProduct,
        [property]: value
      }
    }))
  }

  submitProduct = () => {
    if (
      this.state.newProduct.name !== '' &&
      this.state.newProduct.brand !== '' &&
      this.state.newProduct.quantity !== 0
    ) {
      this.props.addProduct({
        ...this.state.newProduct,
        id: '_' + Math.random().toString(36).substr(2, 9)
      })

      return this.setState({
        feedback: {
          message: 'Product added.',
          type: 'success'
        },
        newProduct: {
          id: '',
          name: '',
          quantity: 0,
          brand: '',
          bought: false
        }
      })
    }

    else if (this.state.newProduct.quantity <= 0) {
      return this.setState({
        feedback: {
          message: 'The "quantity" field can not be less or equal to 0, please update it to 1 or more.',
          type: 'error'
        }
      })
    }

    return this.setState({
      feedback: {
        message: 'The fields "name" and "brand" are required, please fill out those fields with valid information.',
        type: 'error'
      }
    })
  }

  render() {
    return (
      <div>
        <p>{this.state.feedback.message}</p>

        <ProductFormInput
          name='name'
          type='text'
          label='Product Name'
          placeholder='Rice'
          value={this.state.newProduct.name}
          onChange={this.updateNewProductProperty}
        />

        <ProductFormInput
          name='brand'
          type='text'
          label='Brand'
          placeholder='Broto Legal'
          value={this.state.newProduct.brand}
          onChange={this.updateNewProductProperty}
        />

        <ProductFormInput
          name='quantity'
          type='number'
          label='Quantity'
          placeholder='2'
          value={this.state.newProduct.quantity}
          onChange={this.updateNewProductProperty}
        />

        <Button
          onClick={this.submitProduct}>
          {this.state.isSubmitting ? 'Adding product...' : 'Add product'}
        </Button>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    products: state.products
  }
}

export default connect(
  mapStateToProps,
  { addProduct }
)(ProductForm);